import React from "react"
import {Form, Formik} from "formik"
import Button from "../../../components/Button/Button"
import {getAcceptableTypesOfIdentificationValidationSchema} from "../../../components/RiskSettings/AcceptableTypesOfIdentification/AcceptableTypesOfIdentificationUtils"
import {RiskSettingsFieldNames, RiskSettingsType} from "../../../components/RiskSettings/RiskSettingsUtils"
import {noop} from "lodash"
import RiskSettingsEditMode from "../../../components/RiskSettings/RiskSettingsEditMode"
import classNames from "classnames"

interface BankRiskSettingsEditModeProps {
	initialValues: RiskSettingsType
	onCancel: () => void
	onSave: () => void
	formRef: React.RefObject<any>
	title?: string
}

export default function BankRiskSettingsEditMode({
	initialValues,
	onCancel,
	onSave,
	formRef,
	title,
}: BankRiskSettingsEditModeProps) {
	return (
		<>
			<Formik
				initialValues={initialValues}
				validateOnChange
				validationSchema={getAcceptableTypesOfIdentificationValidationSchema(
					RiskSettingsFieldNames.AcceptableTypesOfIdentification
				)}
				onSubmit={noop}
				innerRef={formRef}
			>
				{({values, handleChange, setFieldValue, setFieldTouched, isValid}) => {
					return (
						<Form>
							<div
								className={classNames(
									"mb-5 is-flex",
									title ? "is-justify-content-space-between" : "justify-content-end"
								)}
							>
								{title && <h1 className="has-text-weight-bold is-size-4 is-align-self-center">{title}</h1>}
								<div>
									<Button
										type="button"
										className="mr-3"
										theme="danger"
										variant="outline"
										prefixIcon="delete-close-x"
										onClick={onCancel}
									>
										<span>Cancel</span>
									</Button>
									<Button
										theme="success"
										type="button"
										size="normal"
										variant="outline"
										prefixIcon="approve-v-check-validation"
										onClick={onSave}
										disabled={!isValid}
									>
										<span>Save changes</span>
									</Button>
								</div>
							</div>
							<RiskSettingsEditMode
								value={values}
								handleChange={handleChange}
								setFieldTouched={setFieldTouched}
								setFieldValue={setFieldValue}
							/>
						</Form>
					)
				}}
			</Formik>
		</>
	)
}
